module.exports = __webpack_public_path__ + "static/img/clothing_01.35d21f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/thumbnail/clothing_01.png
// module id = OLOT
// module chunks = 0